export default "__VITE_ASSET__BqpBHLd7__"